module.exports = __webpack_public_path__ + "img/lunette.f69a8272.png";